<template>
  <section>
    <coaching-wall
      ref="coachingWall"
      :to="to"
      @viewing="viewing"
      @edited="edited"
      @valid="valid"
      @sending="sending"
    />
    <overlay
      v-if="isSending"
      :notice="overlayNotice"
      :customStyle="customOverlayStyle"
      @cancel="hideOverlay"
    />
    <button
      class="btn btn-primary me-2 custom-send"
      :disabled="!messageValid || isSending || !isEdited"
      @click="send"
    >
      <i class="fas fa-envelope"></i><span class="ms-2">Send</span>
    </button>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import CoachingWall from '@/Components/Coaching/coaching-wall'
import Overlay from '@/Components/ZElements/Overlay'
export default {
  name: 'client-coachwall',
  components: {
    CoachingWall,
    Overlay,
  },
  data() {
    return {
      isViewing: false,
      messageValid: false,
      isSending: false,
      customOverlayStyle: 'width: 100% !important; height: 100% !important;',
      overlayNotice: 'sending',
      isEdited: false,
    }
  },
  mounted() {
    this.isEdited = false
    this.isSending = false
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('usercardio', ['columns', 'member']),
    to() {
      let _to = null
      if (this.member) {
        _to = {
          id: parseInt(this.member.id),
          user_id: parseInt(this.member.id),
          firstName: this.member.firstName,
          lastName: this.member.lastName,
          nickName: this.member.nickName,
          avatar: this.member.avatar,
          memberids: null,
          type: 'notification',
        }
      }
      console.log('Coaching Wall', _to)
      return _to
    },
  },
  methods: {
    ...mapActions('usercardio', ['setCustomView']),
    viewing(is) {
      this.isViewing = is
    },
    edited(value) {
      this.isEdited = value
    },
    valid(is) {
      this.messageValid = is
    },
    sending(is) {
      this.isSending = is
    },
    send() {
      this.$refs.coachingWall.send()
    },
    hideOverlay() {
      this.isSending = false
    },
    showOverlay() {
      this.isSending = true
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-send {
  position: relative;
  float: right;
}
</style>
